const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12.75 7.25a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zm-.75 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/><path fill-rule="evenodd" d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18" clip-rule="evenodd"/></svg>';
export {
  a as w
};
